import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CardStyles from './Styles';
import CardPreview from './Preview';

class ThemeCard extends Component {
    render() {
        const cardStyles = [
            {
                id: 'theme-text-title',
                tagNameName: 'Title',
                tagName: 'title',
                sampleText: 'Title',
                fontData: this.props.title
            },
            {
                id: 'theme-text-sub-title',
                tagNameName: 'Subtitle',
                tagName: 'subtitle',
                sampleText: 'Subtitle',
                fontData: this.props.subtitle
            },
            {
                id: 'theme-sub-defaultlink',
                tagNameName: 'Link',
                tagName: 'defaultLink',
                sampleText: 'Link',
                fontData: this.props.defaultLink
            },
            {
                id: 'theme-sub-inlinelink',
                tagNameName: 'Inline Link',
                tagName: 'inlineLink',
                sampleText: 'Inline Link',
                fontData: this.props.inlineLink
            },
            {
                id: 'theme-sub-description',
                tagNameName: 'Description',
                tagName: 'description',
                sampleText: 'Description',
                fontData: this.props.description
            },
            {
                id: 'theme-sub-largeprice',
                tagNameName: 'Large Price',
                tagName: 'largePrice',
                sampleText: 'Large Price: $500',
                fontData: this.props.largePrice
            }
        ];
        return (
            <div className="ThemeCard Theme-Content">
                <h1>Card</h1>
                <div className="subpages-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                            <div className="spark-panel__content col-xs-12 col-sm-5">
                                {cardStyles.map(style => {
                                    return (
                                        <div>
                                            <CardStyles
                                                id={style.id}
                                                tagNameName={style.tagNameName}
                                                tagName={style.tagName}
                                                sampleText={style.sampleText}
                                                fontData={style.fontData}
                                            />
                                            <br />
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="col-xs-12 col-sm-2"></div>
                            <div className="col-xs-12 col-sm-4">
                                <CardPreview cardPreview={this.props} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeCard.propTypes = {
    children: PropTypes.element
};

ThemeCard.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.card, ...state.theme.card };
};

export default connect(mapStateToProps)(ThemeCard);



// WEBPACK FOOTER //
// ./src/components/pages/theme/card/index.js